// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ggpce","dark":"styles_dark__g95It","small":"styles_small__zeFPa","sizeXs":"styles_sizeXs__AQFtb"};